import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaBlock } from './ui/CtaBlock';
import { PRODUCT_NAME, tomos } from '../data/content';
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-white" data-id="element-130" data-mp="3o9trxz6mahzz">
      <div className="mx-auto max-w-3xl px-4 py-5 sm:py-8" data-id="element-131" data-mp="3o77mq6778ekx">
        <SectionHeader id="solucion" eyebrow="La solución que estabas buscando — un sistema 6 en 1" title="6 tomos en un solo sistema, creados para ayudarte a planificar, enseñar, practicar y evaluar." data-id="element-132" data-mp="3j9fsv6mzuie3" />
        <p className="mt-2 text-center font-display text-sm font-extrabold text-electric sm:text-base" data-id="element-133" data-mp="3t6kglawhmlx0">
          ⚡ {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1 max-w-2xl text-center text-sm leading-snug text-navy/75" data-id="element-134" data-mp="5v1ayp1och70">
          No es simplemente otro material sobre electricidad. Es un sistema de apoyo docente que organiza clases,
          contenidos, prácticas, evaluaciones y proyectos para que tengas una estructura clara que puedas adaptar a
          tus alumnos.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-135" data-mp="36cysahcpc4pg">
          {tomos.map((tomo, i) => <li key={tomo.title} className="flex gap-2.5 rounded-lg border border-navy/10 bg-mist p-3" data-id="element-136" data-mp="3bbjswhvv8qef" data-mpi={i}>
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-md bg-navy font-display text-lg font-black text-energy" data-id="element-137" data-mp="3fdn3736stoy4">
                {i + 1}
              </span>
              <div data-id="element-138" data-mp="3p7nh9uk264iz">
                <p className="font-display text-[0.7rem] font-semibold text-electric" data-id="element-139" data-mp="3u8b5k8gwk79i">Tomo {i + 1}</p>
                <h3 className="font-display text-sm font-extrabold leading-tight text-navy" data-id="element-140" data-mp="2tdl2z9vzs7n">{tomo.title}</h3>
                <p className="mt-0.5 text-[0.8rem] leading-snug text-navy/75 sm:text-sm" data-id="element-141" data-mp="6vqq1lgt7m3d">{tomo.desc}</p>
              </div>
            </li>)}
        </ol>

        <CtaBlock note="" data-id="element-142" data-mp="bsqwvylhgsvj" />
      </div>
    </section>;
}